export default {
  name: "position-notice",
  props: {
    type: {
      type: String,
      default() {
        return "USER";
      }
    }
  }
};